import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'

import { GroupWorkbookPageDetail } from './GroupWorkbookPageDetail'

type Key = GroupWorkbookPageDetail['id']

export class GroupWorkbookPageDetailColl {
  coll: ExtendedMap<GroupWorkbookPageDetail['id'], GroupWorkbookPageDetail>

  constructor(arr: res.GroupWorkbookPageDetail[]) {
    makeAutoObservable(this)
    this.coll = ExtendedMap.fromArr(
      arr.map((data) => GroupWorkbookPageDetail.from(data)),
      'id',
    )
  }

  get toArr() {
    return this.coll.toArr
  }

  get(key: Key) {
    return this.coll.get(key)
  }

  set(key: Key, value: GroupWorkbookPageDetail) {
    this.coll.set(key, value)
  }
}
